import * as Business from '../business';
import * as User     from '../user';
import { Activity }  from 'react-feather';
import { connect }   from 'react-redux';
import React         from 'react';
import TabPage       from '../components/tab_page';
import TabPageLink   from '../components/tab_page_link';


function MetricsTab({ tabActive, business, isManager, paymentsSettings }) {
  return (
    <TabPage name="metrics" title="Reports">
      <div className="page-content">
        <TabLinks {...{ tabActive, business, isManager, paymentsSettings }}/>
      </div>
    </TabPage>
  );
}

export default connect(
  (state, { businessID }) => ({
    business:         Business.getBusiness(state, businessID),
    isManager:        User.isManager(state, businessID),
    paymentsSettings: Business.getPaymentsSettings(state, businessID)
  })
)(MetricsTab);

function TabLinks({ tabActive, business = {}, isManager, paymentsSettings }) {
  const isPaymentsAvailable = paymentsSettings?.available;
  const isPaymentsEnabled   = paymentsSettings?.enabled;
  const businessID          = business.id;
  const reviews             = `/${businessID}/metrics/reviews`;
  const scorecard           = `/${businessID}/metrics/scorecard`;
  const privateFeedback     = `/${businessID}/metrics/private-feedback`;
  const invoices            = `/${businessID}/metrics/invoices`;
  const dashboard           = `/${businessID}/metrics/dashboard`;
  const showScorecard       = business.settings?.classify !== 'none';

  const showPayments = isManager && isPaymentsAvailable && isPaymentsEnabled;

  return (
    <div className="list media-list">
      <ul>
        <TabPageLink active={tabActive === 'Reviews'} href={reviews} title="Reviews" icon="star">
          View stats and read reviews
        </TabPageLink>
        <TabPageLink
          active={tabActive === 'PrivateFeedback'}
          href={privateFeedback}
          title="Private Feedback"
          icon="quote-from-an-interview">
          See and respond to private feedback
        </TabPageLink>
        {showScorecard &&
          <TabPageLink active={tabActive === 'TeamScorecard'} href={scorecard} title="Team Scorecard" icon="trophy">
            Monitor team member performance
          </TabPageLink>
        }
        {showPayments &&
          <TabPageLink
            active={[ 'Invoices', 'InvoiceDetail' ].includes(tabActive)}
            href={invoices}
            title="Invoices & Payouts"
            icon={<i className="f7-icons invoices-icon">money_dollar</i>}>
          View invoices and payouts details
          </TabPageLink>
        }
        <TabPageLink
          active={[ 'Dashboard' ].includes(tabActive)}
          href={dashboard}
          title="Dashboard"
          icon={<Activity className="dashboard-icon"/>}>
          View business trends and insights
        </TabPageLink>
      </ul>
    </div>
  );
}
